import React, { useEffect, useState } from "react";
import { Button, Card, Modal, Spinner, Alert } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { getUserBooks } from "../../../api/bookService";
import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";
import bookimg1 from "../../../assets/img/bookimg1.jpg"; // Fallback image
const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";
const OLT_icon = "https://d3bn54rc14fhr4.cloudfront.net/ss.png";
export default function BooksInfo() {
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [userBookList, setUserBookList] = useState([]);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);

  const { userId } = useParams();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fetchBooks = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await getUserBooks({
        userId,
        title: searchText.trim(),
      });

      if (response?.data) {
        setUserBookList(response.data);
      } else {
        setError("Failed to retrieve books. Please try again later.");
      }
    } catch (err) {
      console.error("Error fetching books:", err);
      setError("An error occurred while fetching books.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchBooks();
    }
  }, [userId]);

  // const columns = [
  //   {
  //     name: "Name",
  //     minWidth: "280px",
  //     selector: (row) => row.title,
  //     sortable: true,
  //     cell: (row) => (
  //       <>
  //         <img
  //           className="table_img rounded-circle img-thumbnail me-2"
  //           src={
  //             row.coverImage
  //               ? `${MEDIA_URL}/${row.coverImage}`
  //               : bookimg1
  //           }
  //           alt="cover"
  //           width={50}
  //           height={50}
  //         />
  //         {row.title}
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Characters",
  //     minWidth: "190px",
  //     selector: (row) => row.characterCount,
  //     sortable: true,
  //   },
  //   {
  //     name: "Chapters",
  //     minWidth: "180px",
  //     selector: (row) => row.noOfChapters,
  //     sortable: true,
  //   },
  //    {
  //     name: "Date Created",
  //     minWidth: "180px",
  //     selector: (row) => row.createdAt,
  //     sortable: true,
  //     cell: (row) =>
  //       new Date(row.createdAt).toLocaleString("en-IN", {
  //         day: "2-digit",
  //         month: "short",
  //         year: "numeric",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         hour12: true,
  //       }),
  //   },
  //   {
  //     name: "Actions",
  //     minWidth: "150px",
  //     cell: (row) => (
  //       <>
  //         <Link className="btnview" to={`/books/view-book/${row._id}`}>
  //           <Icon icon="tabler:eye" />
  //         </Link>
  //         {/* <span className="btndelete" onClick={handleShow}>
  //           <Icon icon="tabler:trash" />
  //         </span> */}
  //       </>
  //     ),
  //   },
  // ];
  const columns = [
    {
      name: 'SR No.',
      width: '80px',
      cell: (row, index) => index + 1,
      sortable: false,
    },
    {
      name: "Cover",
      width: "100px",
      cell: (row) => (
        <img
          className="table_img rounded-circle img-thumbnail"
          src={row.coverImage ? `${MEDIA_URL}/${row.coverImage}` : OLT_icon}
          alt="cover"
          width={50}
          height={50}
        />
      ),
    },
    {
      name: "Title",
      minWidth: "200px",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => row.title,
    },
    {
      name: "Author",
      minWidth: "190px",
      selector: (row) => row.userId?.fullName || "N/A",
      sortable: true,
      cell: (row) => (
        <Link
          to={`/admin/view-user/${row.userId?._id}?tab=basicinfo`}
          className="text-primary"
          style={{ textDecoration: "none", cursor: "pointer" }}
        >
          {row.userId?.fullName || "N/A"}
        </Link>
      ),
    },
    {
      name: "Username",
      minWidth: "190px",
      selector: (row) => row.userId?.username || "N/A",
      sortable: true,
      cell: (row) => (
        <Link
          to={`/admin/view-user/${row.userId?._id}?tab=basicinfo`}
          className="text-primary"
          style={{ textDecoration: "none", cursor: "pointer" }}
        >
          {row.userId?.username || "N/A"}
        </Link>
      ),
    },
    {
      name: "Characters",
      minWidth: "190px",
      selector: (row) => row.characterCount,
      sortable: true,
    },
    {
      name: "Chapters",
      minWidth: "180px",
      selector: (row) => row.noOfChapters,
      sortable: true,
    },
    {
      name: "Date Created",
      minWidth: "180px",
      selector: (row) => row.createdAt,
      sortable: true,
      cell: (row) => {
        const date = new Date(row.createdAt);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
    },
    {
      name: "Actions",
      minWidth: "150px",
      cell: (row) => (
        <>
          <Link className="btnview" to={`/books/view-book/${row._id}`}>
            <Icon icon="tabler:eye" />
          </Link>
        </>
      ),
    },
  ];

  const filteredData = userBookList.filter((item) =>
    JSON.stringify(item).toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Card>
        <Card.Body className="bookingtable mt-3">
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              responsive
              className="custom-table"
              noDataComponent={
                <p className="text-center my-4">No books found</p>
              }
            />
          )}
        </Card.Body>
      </Card>

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            onClick={handleClose}
            className="btn btn-primary-outline px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            onClick={handleClose}
            className="btn btn-primary px-4 min_width110"
          >
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
